import React from 'react';
import AppStoreLinks from './AppStoreLinks';
import AppStoreQRCodes from './AppStoreQRCodes';

const AppStoreMobileSection = ({
  qrSize = 88,
  showQr = true,
  className = '',
  titleClassName = 'text-sm font-semibold text-white',
  align = 'start',
  badgeClassName = 'h-10 w-auto',
}) => (
  <div className={`space-y-4 ${align === 'center' ? 'text-center' : ''} ${className}`}>
    <p className={titleClassName}>Get the mobile app</p>
    <AppStoreLinks
      variant="badges"
      badgeClassName={badgeClassName}
      className={align === 'center' ? 'justify-center' : ''}
    />
    {showQr && (
      <AppStoreQRCodes
        size={qrSize}
        className={align === 'center' ? 'justify-center' : ''}
      />
    )}
  </div>
);

export default AppStoreMobileSection;
